// extracted by mini-css-extract-plugin
export default {"FacetHelp":"xq_a bhc_jh bhc_sy","FacetHelp__paragraph":"xq_b bhc_vr bhc_xe","FacetHelp__youtube":"xq_c"};